var _defs, _g, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRubFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "circleMask"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#circleMask)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 10.6667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 10.6667,
    width: 32,
    height: 10.6667,
    fill: "#0039A6"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 21.3333,
    width: 32,
    height: 10.6667,
    fill: "#D52B1E"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "none",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubFlag);
export default __webpack_public_path__ + "static/media/rubFlag.fc2df5f24bf93c27be7312b08f8cfcd1.svg";
export { ForwardRef as ReactComponent };